/**
 * StatTile.jsx — iter847 (Feb 2026) · iter902 tooltip added
 * Small gradient card showing a labelled metric (BMI / Age / etc.) with
 * fallback ComputeIndexCTA when the value is missing.
 */
import React, { useState } from "react";
import ComputeIndexCTA from "@/components/ComputeIndexCTA";
import { Info } from "lucide-react";

export default function StatTile({ label, value, testid, computeRoute, computeLabel, lang = "bg", isDark = false, tooltip }) {
  const isMissing = value === null || value === undefined || value === "—" || value === 0;
  const [hovered, setHovered] = useState(false);
  const [pinned, setPinned]   = useState(false);
  const showTip = tooltip && (hovered || pinned);

  // Close pinned tooltip on outside click
  React.useEffect(() => {
    if (!pinned) return;
    const onDoc = (e) => {
      if (!e.target.closest?.(`[data-testid="${testid}"]`)) setPinned(false);
    };
    document.addEventListener("click", onDoc);
    return () => document.removeEventListener("click", onDoc);
  }, [pinned, testid]);
  return (
    <div
      className="p-3 rounded-xl bg-gradient-to-br from-pink-500/10 to-purple-500/10 border border-pink-200/30 dark:border-pink-500/20 relative"
      data-testid={testid}
    >
      <div className="text-[11px] opacity-60 mb-0.5 flex items-center gap-1">
        <span>{label}</span>
        {tooltip && (
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); setPinned(v => !v); }}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            className="opacity-60 hover:opacity-100 focus:outline-none"
            data-testid={`${testid}-info`}
            aria-label="Info"
          >
            <Info className="w-3 h-3" />
          </button>
        )}
      </div>
      <div className="text-2xl font-bold">{value}</div>
      {isMissing && computeRoute && (
        <div className="mt-1">
          <ComputeIndexCTA
            value={value}
            route={computeRoute}
            label_bg={computeLabel}
            label_en={computeLabel}
            lang={lang}
            isDark={isDark}
            size="xs"
            testid={`${testid}-compute`}
          />
        </div>
      )}
      {tooltip && showTip && (
        <div
          className={`absolute z-30 top-full left-0 mt-1 w-64 sm:w-72 p-3 rounded-xl shadow-xl text-[11px] leading-relaxed ${
            isDark ? "bg-slate-900 border border-slate-700 text-slate-100"
                   : "bg-white border border-slate-200 text-slate-800"
          }`}
          data-testid={`${testid}-tooltip`}
          role="tooltip"
        >
          {tooltip}
        </div>
      )}
    </div>
  );
}
